export const VARIANT_LINK = 'link';
export const VARIANT_PRIMARY = 'primary';
export const VARIANT_SECONDARY = 'secondary';
